var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.718,
    height: 89.718,
    viewBox: "0 0 89.718 89.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_viviendas",
    transform: "translate(-306 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 89.718,
    height: 89.718,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8218",
    "data-name": "Group 8218",
    transform: "translate(136.19 897.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19837",
    "data-name": "Path 19837",
    d: "M309.013,90.266h-.082c-4.716-1.08-4.716-3.056-4.716-3.667,0-2.475,2.159-3.6,4.156-3.6h0a4.146,4.146,0,0,1,3.84,2.546,2.536,2.536,0,1,0,4.655-1.966,9.169,9.169,0,0,0-5.98-5.307v-2.2a2.546,2.546,0,0,0-5.093,0v2.149a8.536,8.536,0,0,0-6.691,8.353c0,2.465,1.12,6.845,8.567,8.576h.082c4.716,1.08,4.716,3.056,4.716,3.667,0,2.475-2.159,3.6-4.156,3.6h0a4.146,4.146,0,0,1-3.789-2.536,2.536,2.536,0,1,0-4.675,1.956,9.168,9.168,0,0,0,5.979,5.307v2.21a2.546,2.546,0,1,0,5.093,0V107.2a8.536,8.536,0,0,0,6.662-8.342c0-2.475-1.069-6.855-8.566-8.6Z",
    transform: "translate(-93.692 -49.023)",
    fill: "#0595f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19838",
    "data-name": "Path 19838",
    d: "M244.757,43.728a30.12,30.12,0,1,0-8.833,21.248,30.088,30.088,0,0,0,8.833-21.248Zm-30.09,24.986a25.046,25.046,0,1,1,17.676-7.321A25.027,25.027,0,0,1,214.668,68.714Z",
    transform: "translate(0)",
    fill: "#0595f0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoney);
export default __webpack_public_path__ + "static/media/ico_money.500938be050e561cb39c4695fd4514de.svg";
export { ForwardRef as ReactComponent };